import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouterService } from '../services/router.service';
import { StorageService } from '../services/storage.service';

@Injectable({
    providedIn: 'root',
})
export class RoleRedirectGuard {
    constructor(
        private storage: StorageService,
        private router: RouterService
    ) {}

    public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentRole = this.storage.getRole();
        if (!currentRole) {
            this.router.navigateToRoleSelection();
            return false;
        }
        return true;
    }
}
